import type { Bet, MOutcomes } from '../../coupon/entry.js';
import { OUTCOME_MAP_1X2 } from './utils.js';

type ParseMSYS1x2Result = {
  mOutcomes: MOutcomes;
  outcomes: Bet;
};

/**
 * Parses a 1x2 board with optional M outcomes.
 *
 * @param boardData The board data to parse.
 * @returns The parsed board data.
 */
export function parseMSys1x2(boardData: string[]): ParseMSYS1x2Result {
  const mOutcomes: MOutcomes = [];
  const outcomes: Bet = [];

  for (const betEvent of boardData) {
    const betEventOutcomeGroups: Bet[0] = [];
    const betEventOutcomes: Bet[0][0] = [];

    mOutcomes.push(betEvent.includes('M'));

    for (const wagerOutcome of betEvent.replace('M', '')) {
      const outcome = OUTCOME_MAP_1X2.get(wagerOutcome);

      if (outcome === undefined) {
        continue;
      }

      betEventOutcomes.push(outcome);
    }

    betEventOutcomeGroups.push(betEventOutcomes);
    outcomes.push(betEventOutcomeGroups);
  }

  return {
    mOutcomes,
    outcomes,
  } as const;
}
